import { BUCKET_NAME, ACCESS_KEY_ID, SECRET_ACCESS_KEY } from './.constants'

export const config = {
    bucketName: BUCKET_NAME,
    dirName: 'mobioastro', /* optional */
    region: 'eu-west-1',
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: SECRET_ACCESS_KEY,
}



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/addAccount/config.js